import { useState } from "react";

const C = {
  surface2:"#202020", border:"#2a2a2a", muted:"#666",
  orange:"#FF5F1F", magenta:"#E8197D", white:"#fff", red:"#f87171",
};

const inp = (x={}) => ({ background:C.surface2, border:`0.5px solid ${C.border}`, borderRadius:8, padding:"9px 12px", color:C.white, fontSize:13, outline:"none", width:"100%", boxSizing:"border-box", ...x });
const btn = (v="primary",x={}) => ({ padding:"8px 16px", borderRadius:8, fontSize:13, fontWeight:500, cursor:"pointer", border:"none", boxSizing:"border-box", ...(v==="primary"?{background:`linear-gradient(135deg,${C.orange},${C.magenta})`,color:C.white}:{}), ...x });

export function RehearsalEditor({ items, onChange }) {
  const [date,setDate]=useState("");
  const [timeFrom,setTimeFrom]=useState("");
  const [timeTo,setTimeTo]=useState("");
  const [loc,setLoc]=useState("");
  const [comment,setComment]=useState("");
  const [dateErr,setDateErr]=useState("");

  const add=()=>{
    if(!date||!timeFrom) return;
    if(new Date(date+"T23:59:59") < new Date()){ setDateErr("Kan ikke legge til øving tilbake i tid."); return; }
    setDateErr("");
    onChange([...items,{id:Date.now(),date,timeFrom,timeTo,location:loc,comment}]
      .sort((a,b)=>new Date(a.date+"T"+a.timeFrom)-new Date(b.date+"T"+b.timeFrom)));
    setDate(""); setTimeFrom(""); setTimeTo(""); setLoc(""); setComment("");
  };

  const fmt=d=>new Date(d+"T12:00:00").toLocaleDateString("nb-NO",{day:"numeric",month:"short"});

  return (
    <div>
      {items.map(r=>(
        <div key={r.id} style={{marginBottom:8,padding:"10px 12px",background:C.surface2,borderRadius:8,borderLeft:`3px solid ${C.magenta}`}}>
          <div style={{display:"flex",alignItems:"center",gap:8,flexWrap:"wrap"}}>
            <div style={{fontFamily:"monospace",fontSize:12,color:C.white,minWidth:72}}>{r.date?fmt(r.date):""}</div>
            <div style={{fontFamily:"monospace",fontSize:12,color:C.white}}>{r.timeFrom}{r.timeTo?` – ${r.timeTo}`:""}</div>
            {r.location&&<div style={{fontSize:13,color:"#ccc",flex:1}}>{r.location}</div>}
            <button onClick={()=>onChange(items.filter(x=>x.id!==r.id))} style={{background:"none",border:"none",color:"#555",cursor:"pointer",fontSize:18,flexShrink:0,marginLeft:"auto"}}>×</button>
          </div>
          {r.comment&&<div style={{fontSize:12,color:C.muted,marginTop:4}}>{r.comment}</div>}
        </div>
      ))}
      <div style={{marginTop:12,padding:"12px",background:"#141414",borderRadius:8,border:`0.5px dashed ${C.border}`}}>
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr 1fr",gap:8,marginBottom:dateErr?4:8}}>
          <div>
            <div style={{fontSize:11,color:C.muted,marginBottom:4,textTransform:"uppercase",letterSpacing:0.5}}>Dato for øving</div>
            <input style={inp({height:44,boxSizing:"border-box"})} type="date" value={date} min={new Date().toISOString().split("T")[0]} onChange={e=>{setDate(e.target.value);setDateErr("");}}/>
          </div>
          <div>
            <div style={{fontSize:11,color:C.muted,marginBottom:4,textTransform:"uppercase",letterSpacing:0.5}}>Sted</div>
            <input style={inp({height:44,boxSizing:"border-box"})} placeholder="Sted / studio..." value={loc} onChange={e=>setLoc(e.target.value)}/>
          </div>
          <div>
            <div style={{fontSize:11,color:C.muted,marginBottom:4,textTransform:"uppercase",letterSpacing:0.5}}>Tid fra</div>
            <input style={inp({height:44,boxSizing:"border-box"})} type="time" value={timeFrom} onChange={e=>setTimeFrom(e.target.value)}/>
          </div>
          <div>
            <div style={{fontSize:11,color:C.muted,marginBottom:4,textTransform:"uppercase",letterSpacing:0.5}}>Til</div>
            <input style={inp({height:44,boxSizing:"border-box"})} type="time" value={timeTo} onChange={e=>setTimeTo(e.target.value)}/>
          </div>
        </div>
        {dateErr&&<div style={{fontSize:12,color:C.red,marginBottom:6}}>{dateErr}</div>}
        <div style={{display:"flex",gap:8,alignItems:"flex-end",marginTop:8}}>
          <div style={{flex:1}}>
            <div style={{fontSize:11,color:C.muted,marginBottom:4,textTransform:"uppercase",letterSpacing:0.5}}>Kommentar</div>
            <input style={inp({height:44,boxSizing:"border-box"})} placeholder="Valgfritt..." value={comment} onChange={e=>setComment(e.target.value)} onKeyDown={e=>e.key==="Enter"&&add()}/>
          </div>
          <button style={btn("primary",{flexShrink:0,height:44})} onClick={add}>+ Legg til</button>
        </div>
      </div>
    </div>
  );
}